import { Button, IconMessage } from '@act/storybook';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const UnauthorizedMemberAccess = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'grid',
        justifyItems: 'center',
        alignContent: 'center',
        padding: 3,
      }}
    >
      <Box sx={{ maxWidth: '480px', textAlign: 'center' }}>
        <IconMessage
          message="Access Denied"
          subMessage="You do not have access to view this member's information. If you believe this is a mistake, please contact your administrator for assistance."
          iconName="Prohibit"
          iconColor="error"
        />
        <Box
          sx={{
            marginTop: 3,
            display: 'flex',
            gap: 2,
            justifyContent: 'center',
          }}
        >
          <Button
            variant="outlined"
            onClick={() => navigate('/docket')}
            trackingName="go-to-docket-from-unauthorized-member"
          >
            Return to Docket
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default UnauthorizedMemberAccess;
